/**
 * ── A TRANCA DE ORDEM, NO APP DO ALUNO ─────────────────────────────────────
 *
 * A derivação MUDOU-SE para o core em 23/09/2026 — `@vestigo/core/area-frase-da-tranca-de-ordem` —,
 * e é de lá que ela sai agora, para o **403 do servidor** e o app do telemóvel
 * dizerem exatamente o que estas telas dizem. Era dívida declarada no cabeçalho
 * que estava aqui, e durou umas horas.
 *
 * O que fica: `destinoDaTranca`, que é a única parte que depende das ROTAS deste
 * app — o core não sabe, nem deve saber, que `/c/:id` existe.
 *
 * A reexportação não é preguiça: as cercas desta pasta importam daqui, e
 * mantê-las a apontar para cá é o que prova que a mudança de casa não trocou uma
 * palavra da frase.
 */
export {
  SEM_MOTIVO,
  /* No core ela chama-se `fraseDaTrancaDeOrdem`, para não disputar o nome com a
     frase da tranca por AVALIAÇÃO (`tranca-por-avaliacao.ts`). Aqui dentro só
     existe uma tranca com frase, e o nome curto é o que as telas já usam. */
  fraseDaTrancaDeOrdem as fraseDaTranca,
  lerTranca,
  medidasDaTranca,
  partesDaFrase,
  type EspecieExigida,
  type FraseDaTranca,
  type MedidaDaTranca,
  type TrancaDeOrdem,
} from '@vestigo/core/area-frase-da-tranca-de-ordem';

import type { TrancaDeOrdem } from '@vestigo/core/area-frase-da-tranca-de-ordem';

/**
 * Para onde o nome do que falta leva — ou `null`, e aí ele não é link.
 *
 * Só curso e aula têm rota no app do aluno. O módulo não tem página própria e a
 * trilha abre por **slug**, que o motor não manda no `exigeId`; linkar um uuid
 * para `/trilha/:slug` daria 404, e um link que não abre é pior do que texto.
 *
 * O destino pode estar ele próprio trancado (A espera B, B espera C). Isso é
 * correto e é a cadeia a funcionar: lá a pessoa lê o passo seguinte dela, com a
 * mesma frase, em vez de ficar a olhar para dois cadeados sem ordem.
 */
export function destinoDaTranca(t: TrancaDeOrdem): string | null {
  if (t.exigeId === '') return null;
  if (t.exigeTipo === 'curso') return `/c/${t.exigeId}`;
  if (t.exigeTipo === 'aula') return `/aula/${t.exigeId}`;
  return null;
}
